import React from 'react';

function Button({ handleClick }) {
  return (
    <button className="btn -white" type="button" id="checkout-button" role="link" onClick={handleClick}>
      Buy Support
    </button>
  );
}

export default Button;



// WEBPACK FOOTER //
// ./app/javascript/components/buy_support_panel/components/UI/Button.js